import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Observable, of } from 'rxjs';

@Injectable ({
  providedIn: 'root',
})
export class AuthService {
   httpClient = inject(HttpClient);
   router = inject(Router);
   baseUrl = 'https://api.tridimo.de/api';
   userData: any
   storedData: any
   apiUrl = environment.apiUrl;
   testUrl = 'https://test.api.tridimo.de/api/'
   ProductionUrl = 'https://api.tridimo.de/api/'
   constructor(private http: HttpClient) { }

   /**
 * Führt den Login durch und speichert die Userdaten im Local Storage.
 * Unterscheidet zwischen Test- und Produktionsumgebung.
 */
   login(data: any) {
    console.log(data);
    if(this.apiUrl === 'https://test.api.tridimo.de/api/') {
      return this.httpClient.post(`https://dev.api.tridimo.de/api/auth/login`, data)
      .pipe(tap((result) => {
        localStorage.setItem('authUser', JSON.stringify(result));
    }));
    } else {
      return this.httpClient.post(`${this.apiUrl}auth/login`, data, {
        withCredentials: this.apiUrl === this.testUrl || this.apiUrl === this.ProductionUrl,
      }).pipe(
        tap((result) => {
          localStorage.setItem('authUser', JSON.stringify(result));
        })
    )}
  }

  /**
 * Meldet den Benutzer serverseitig und lokal ab.
 * Ruft Logout-Endpunkt auf und löscht anschließend lokale Daten.
 */
   logout() {
    if(this.apiUrl === 'https://test.api.tridimo.de/api/') {
      this.httpClient.post(`https://dev.api.tridimo.de/api/auth/logout`, {}).subscribe({
        next: () => {
          this.clearLocalData();
        },
        error: (err) => {
          console.error('Fehler beim Server-Logout:', err);
          this.clearLocalData();
        }
      });
    } else {
      this.httpClient.post(`${this.apiUrl}auth/logout`, {}).subscribe({
        next: () => {
          this.clearLocalData();
        },
        error: (err) => {
          console.error('Fehler beim Server-Logout:', err);
          this.clearLocalData();
        }
      });
    }
  }
  
  /**
 * Entfernt alle lokalen Auth-Daten und leitet zum Login weiter.
 * Setzt zusätzlich die Browser-History sauber zurück.
 */
  private clearLocalData() {
    localStorage.removeItem('authUser')
    localStorage.removeItem('role')
    localStorage.removeItem('firstName')
    localStorage.removeItem('lastName')

    this.router.navigate(['login']).then(() => {
      window.history.replaceState(null, '', '/login');
    });
  }
  
/**
 * Prüft, ob ein User aktuell eingeloggt ist.
 * Grundlage ist das Vorhandensein von authUser im Local Storage.
 */
   isLoggedIn() {
     return localStorage.getItem('authUser') !== null;
   }

   /**
 * Prüft die aktuelle Session beim Backend.
 * Gibt Observable zurück und fängt Fehler sauber ab.
 */
   public checkSession(): Observable<any> {
      return this.http.get(`${this.apiUrl}user/details`, this.getAuthOptions()).pipe(
        catchError((error) => of(error))
      );
  }

  /**
 * Baut die HTTP Auth-Options abhängig vom Auth-Modus.
 * Nutzt entweder Token-Header oder Cookie-basierte Auth.
 */
  private getAuthOptions(): { headers?: HttpHeaders; withCredentials?: boolean } {
    const useTokenAuth = environment.useTokenAuth;
    const storedData = localStorage.getItem('authUser');
    let token = '';
    let exp = '';

    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        token = parsedData.token;
        exp = parsedData.exp;
        this.checkToken(exp);
      } catch (e) {
        this.logout();
      }
    } else {
      this.logout();
    }

    if (useTokenAuth) {
      return {
        headers: new HttpHeaders({
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        })
      };
    } else {
      return {
        withCredentials: true
      };
    }
  }

  /**
 * Prüft, ob der Token abgelaufen ist.
 * Bei Ablauf wird automatisch logout() ausgeführt.
 */
   checkToken(token: any) {
    try {
      const expirationTime = token * 1000;
      const currentTime = Date.now();
      if (currentTime - expirationTime > 3600000) {
        this.logout();
      }
    } catch (e) {
      this.logout();
    }
  }
}
